import { Injectable, inject } from '@angular/core';
import { AccountService } from '@app/_services/account.service';
import { OAuthService } from 'angular-oauth2-oidc';

/** Refreshes the access token for both the Angular HttpClient and the React axios instance. */
@Injectable({
  providedIn: 'root',
})
export class TokenRefreshService {
  private readonly oauthService = inject(OAuthService);
  private readonly accountService = inject(AccountService);

  private inFlight: Promise<void> | null = null;

  /**
   * Refreshes the access token. Concurrent calls share one refresh.
   * On failure the user is logged out and the returned promise rejects.
   */
  refresh(): Promise<void> {
    this.inFlight ??= this.doRefresh().finally(() => (this.inFlight = null));
    return this.inFlight;
  }

  private async doRefresh(): Promise<void> {
    // Refreshing is impossible before the OAuth service is configured (tokenEndpoint is only set once the
    // application config has arrived) or without a stored refresh token — refreshToken() would throw
    // "'tokenEndpoint' should not be null".
    if (!this.oauthService.tokenEndpoint || !this.oauthService.getRefreshToken()) {
      this.accountService.logout();
      throw new Error('Token refresh not possible: OAuth not configured or no refresh token');
    }

    try {
      await this.oauthService.refreshToken();
    } catch (error) {
      this.accountService.logout();
      throw error;
    }
  }
}
